// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface INewbuildingLabel {
  /** Текст **/
  text: string;
  /** Тип **/
  type: EType;
}

export enum EType {
  /** Эксклюзивная акция **/
  'PromoExclusive' = 'promoExclusive',
  /** Льготная ипотека **/
  'DiscountMortgage' = 'discountMortgage',
  /** Промо для примиум ЖК **/
  'PremiumPromo' = 'premiumPromo',
  /** Промо для обычного ЖК **/
  'Promo' = 'promo',
  /** Онлайн-бронирование **/
  'NewbuildingBrokerBooking' = 'newbuildingBrokerBooking',
}
